export enum ExtraColumnDataItemsIdsEnum {
  registered_at = 'registered_at',
  tags = 'tags',
}

export const extraColumnDataItemsLocoKeys = {
  [ExtraColumnDataItemsIdsEnum.registered_at]: 'dashboard.contacts.registered_at',
  [ExtraColumnDataItemsIdsEnum.tags]: 'dashboard.tag.title_plural',
}
